
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h30v30H0z"}})])]),_c('g',{attrs:{"data-name":"Artboard – 2","clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"rgba(255,255,255,0)","d":"M0 0h30v30H0z"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 32476","d":"M7.454 1.426h12.7a1 1 0 01.722.308l4.9 5.112a1 1 0 01.278.692v17.521a3.519 3.519 0 01-3.515 3.515H7.454a3.519 3.519 0 01-3.515-3.515V4.941a3.519 3.519 0 013.515-3.515zm12.273 2H7.454a1.516 1.516 0 00-1.515 1.515v20.118a1.516 1.516 0 001.515 1.515h15.085a1.516 1.516 0 001.515-1.515V7.94z"}}),_c('path',{attrs:{"data-name":"Path 32477","d":"M25.057 9.703h-5.605a1 1 0 01-1-1V2.426a1 1 0 112 0v5.277h4.605a1 1 0 010 2z"}}),_c('path',{attrs:{"data-name":"Line 1563","d":"M14.939 21.426a1 1 0 01-1-1v-9.074a1 1 0 011-1 1 1 0 011 1v9.074a1 1 0 01-1 1z"}}),_c('path',{attrs:{"data-name":"Line 1564","d":"M18.939 16.889h-8a1 1 0 01-1-1 1 1 0 011-1h8a1 1 0 011 1 1 1 0 01-1 1z"}})])])])
          )
        }
      }
    